var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnauthorizedFr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 1115 789",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 302.74,
    y1: -503.46,
    x2: 936.09,
    y2: -503.46,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 442.49,
    y1: -310.55,
    x2: 450.31,
    y2: -313.99,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -35297.87,
    y1: 15382.76,
    x2: -34744.26,
    y2: 15139.66,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 472.72,
    y1: -324.47,
    x2: 480.45,
    y2: -327.87,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -29765.33,
    y1: 12957.76,
    x2: -29386.3,
    y2: 12791.26,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 485.99,
    y1: -330.59,
    x2: 493.64,
    y2: -333.96,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 498.01,
    y1: -336.07,
    x2: 502.05,
    y2: -337.84,
    gradientTransform: "translate(-8.36 923.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 744.951,
    y1: 496.26,
    x2: 744.951,
    y2: 527.67,
    id: "gradient-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(72.941% 85.49% 33.333%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(37.355% 50.439% 0%)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 744.951,
    cy: 511.965,
    r: 105.53,
    id: "gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(72.941% 85.49% 33.333%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(37.355% 50.439% 0%)"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m943.93,0L0,789h1114.35V0h-170.42Z",
    fill: "#edf5f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m434.19,0l166.15,620.1c7.15,26.67,34.56,42.5,61.24,35.36l453.42-121.49V0H434.19Z",
    fill: "#1981ad"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m792.24,160.26l-369.2,160.11,10.38,23.25c.33.71.52,1.49.55,2.28.03.79-.1,1.57-.38,2.31s-.71,1.41-1.25,1.98c-.55.57-1.2,1.02-1.92,1.34-.73.32-1.51.49-2.3.5-.79.01-1.58-.13-2.32-.42-.74-.29-1.41-.73-1.98-1.28-.57-.55-1.02-1.21-1.33-1.94l-10.4-23.27-109.27,47.39c-7.81,3.4-10.4,13.31-6.94,20.96l126.71,279.75c3.39,7.48,11.37,9.68,19,6.12l106.57-49.77-9.15-20.48c-.66-1.43-.72-3.07-.17-4.55.55-1.48,1.66-2.68,3.09-3.34.7-.33,1.46-.52,2.23-.55.77-.03,1.54.09,2.27.37.72.27,1.39.69,1.94,1.22.56.54,1.01,1.18,1.31,1.89l9.14,20.47,360.33-168.27c6.98-3.26,10.55-10.59,7.46-17.79l-115.36-269.4c-3.13-7.34-11.9-11.95-19.04-8.85l.03-.03Zm-254.58,416.78c.65,1.43.71,3.07.16,4.55-.55,1.48-1.66,2.68-3.09,3.34-.7.34-1.47.53-2.25.56s-1.56-.09-2.28-.37c-.73-.27-1.4-.69-1.96-1.23s-1.01-1.18-1.32-1.9l-13.73-30.79c-.33-.71-.51-1.48-.54-2.26-.03-.78.1-1.56.37-2.3.27-.73.69-1.4,1.22-1.98s1.17-1.04,1.88-1.36c.71-.33,1.48-.51,2.26-.54s1.56.1,2.29.39c.73.28,1.39.7,1.96,1.25.56.54,1.01,1.19,1.31,1.91l13.72,30.73h0Zm-25.88-57.95c.33.71.51,1.48.54,2.26.03.78-.1,1.56-.37,2.3-.27.73-.69,1.41-1.22,1.98s-1.18,1.03-1.89,1.36c-.71.33-1.48.51-2.25.53-.78.02-1.56-.11-2.28-.39-.73-.28-1.39-.7-1.95-1.24s-1.01-1.19-1.32-1.91l-13.81-30.92c-.65-1.43-.7-3.07-.14-4.54s1.68-2.66,3.11-3.31,3.06-.7,4.53-.14,2.66,1.68,3.31,3.11l13.75,30.9h0Zm-26-58.2c.35.71.55,1.49.59,2.28.04.79-.08,1.59-.35,2.34-.27.75-.69,1.43-1.23,2.01s-1.19,1.05-1.92,1.38c-.72.33-1.51.5-2.3.52-.79.02-1.58-.13-2.32-.42-.74-.29-1.41-.73-1.97-1.29-.57-.56-1.01-1.23-1.31-1.96l-13.89-31.06c-.35-.72-.56-1.5-.6-2.3s.07-1.6.35-2.35c.27-.75.69-1.44,1.24-2.03s1.2-1.05,1.93-1.38,1.52-.5,2.32-.51c.8-.01,1.59.14,2.33.44s1.41.75,1.97,1.32,1,1.25,1.3,1.99l13.86,31.02h0Zm-26.12-58.49c.32.71.49,1.48.51,2.26.02.78-.12,1.56-.4,2.29s-.7,1.39-1.24,1.96c-.54.57-1.18,1.02-1.9,1.34-.71.32-1.48.49-2.26.51s-1.56-.12-2.29-.4-1.39-.71-1.96-1.24c-.56-.54-1.02-1.18-1.33-1.9l-13.96-31.21c-.33-.71-.52-1.49-.55-2.28-.03-.79.1-1.57.38-2.31s.7-1.41,1.25-1.98c.54-.57,1.2-1.02,1.92-1.34s1.5-.49,2.29-.5,1.57.13,2.31.42,1.4.72,1.97,1.27c.57.55,1.02,1.21,1.34,1.93l13.91,31.19h0Z",
    fill: "url(#b)",
    isolation: "isolate",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m798.93,148.97l-368.74,159.62,10.37,23.25c.33.71.52,1.49.55,2.28.03.79-.1,1.57-.38,2.31s-.7,1.41-1.25,1.98c-.54.57-1.2,1.02-1.92,1.34-.73.32-1.51.48-2.3.5-.79.01-1.58-.13-2.31-.42-.74-.29-1.41-.73-1.97-1.28s-1.02-1.21-1.33-1.94l-10.39-23.26-109.13,47.24c-7.81,3.38-10.39,13.29-6.93,20.94l126.61,279.71c3.38,7.47,11.36,9.69,18.98,6.14l106.44-49.62-9.15-20.48c-.65-1.43-.72-3.07-.17-4.55.55-1.48,1.66-2.68,3.09-3.34.7-.33,1.46-.52,2.23-.55.77-.03,1.54.09,2.27.37.72.27,1.38.69,1.94,1.23s1,1.18,1.31,1.89l9.13,20.46,359.85-167.77c6.97-3.25,10.53-10.58,7.45-17.78l-115.21-269.35c-3.16-7.36-11.91-11.96-19.04-8.87v-.05Zm-254.26,416.25c.66,1.43.72,3.07.17,4.55-.55,1.48-1.66,2.68-3.09,3.34-.7.33-1.46.51-2.24.55-.77.03-1.55-.1-2.27-.37-.73-.27-1.39-.69-1.95-1.23s-1.01-1.18-1.31-1.89l-13.74-30.77c-.33-.71-.51-1.48-.54-2.26-.03-.78.1-1.56.37-2.3.27-.73.69-1.4,1.22-1.98.53-.57,1.18-1.03,1.89-1.36.71-.33,1.47-.51,2.25-.54.78-.03,1.56.1,2.29.38s1.39.7,1.95,1.25,1.01,1.19,1.31,1.91l13.69,30.72h0Zm-25.82-57.93c.33.71.51,1.48.54,2.26.03.78-.1,1.56-.37,2.29s-.69,1.41-1.22,1.98c-.53.57-1.18,1.03-1.89,1.36-.71.33-1.47.51-2.25.53s-1.56-.11-2.28-.39c-.73-.28-1.39-.7-1.95-1.24s-1.01-1.19-1.32-1.9l-13.81-30.91c-.32-.71-.5-1.47-.53-2.25s.1-1.55.37-2.28c.27-.73.69-1.4,1.22-1.97.53-.57,1.17-1.03,1.88-1.35.71-.32,1.48-.5,2.26-.52s1.55.11,2.28.39,1.39.7,1.96,1.23c.57.54,1.02,1.18,1.34,1.89l13.79,30.89h-.02Zm-25.98-58.21c.33.71.51,1.48.54,2.27.03.79-.1,1.57-.37,2.3-.28.73-.7,1.41-1.23,1.98-.54.57-1.18,1.03-1.9,1.35-.72.32-1.49.49-2.27.51s-1.56-.12-2.29-.41-1.4-.72-1.96-1.26c-.56-.55-1.01-1.2-1.32-1.92l-13.87-31.06c-.38-.72-.6-1.51-.66-2.32s.05-1.62.31-2.39c.27-.77.69-1.47,1.24-2.07.55-.6,1.21-1.08,1.96-1.4.74-.33,1.54-.5,2.35-.51.81,0,1.62.15,2.36.47.75.32,1.42.78,1.98,1.37.56.59.99,1.28,1.27,2.04l13.87,31.06h0Zm-26.08-58.5c.64,1.44.68,3.07.11,4.54s-1.69,2.65-3.13,3.29-3.07.68-4.54.11-2.65-1.69-3.29-3.13l-13.94-31.21c-.33-.71-.52-1.49-.55-2.28-.03-.79.1-1.57.38-2.31s.7-1.41,1.25-1.98c.54-.57,1.2-1.02,1.92-1.34.72-.31,1.5-.48,2.29-.49s1.57.13,2.31.42c.73.29,1.4.72,1.97,1.27.57.55,1.02,1.21,1.33,1.93l13.89,31.17h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m453.19,635.21c.42.96.44,2.05.06,3.03s-1.12,1.77-2.08,2.2c-.46.22-.97.35-1.49.38s-1.03-.05-1.52-.22c-.49-.17-.93-.44-1.31-.79-.38-.35-.69-.77-.91-1.24l-23.06-51.08c-.42-.96-.44-2.05-.06-3.04.38-.98,1.13-1.77,2.09-2.2.47-.22.98-.35,1.5-.37s1.04.05,1.53.23c.49.18.94.45,1.32.8.38.35.69.77.91,1.24l23.02,51.06h0Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.62,627.4c.91,2-.5,4.62-3.18,5.86s-5.55.6-6.46-1.39l-22.96-50.94c-.91-2.01.51-4.63,3.2-5.86,2.69-1.2,5.57-.6,6.48,1.43l22.92,50.9h0Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.29,621.25c.42.96.44,2.04.07,3.02-.38.98-1.12,1.76-2.07,2.2-.46.22-.97.35-1.48.38s-1.03-.05-1.51-.22c-.48-.17-.93-.44-1.31-.79-.38-.35-.68-.77-.9-1.24l-22.93-50.95c-.42-.96-.45-2.05-.07-3.03s1.13-1.77,2.08-2.2c.47-.22.97-.35,1.49-.37s1.03.06,1.52.23.93.45,1.31.8c.38.35.69.77.9,1.24l22.9,50.93h0Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518,605.17c.41.95.44,2.03.07,3.01-.37.97-1.11,1.76-2.06,2.19-.46.22-.96.35-1.47.37-.51.02-1.02-.05-1.5-.23-.48-.18-.92-.44-1.3-.79-.38-.35-.68-.77-.89-1.23l-22.78-50.83c-.42-.96-.44-2.04-.07-3.01.38-.97,1.12-1.76,2.07-2.19.47-.22.97-.34,1.48-.36s1.03.06,1.51.23c.48.18.93.45,1.3.8.38.35.68.77.89,1.24l22.74,50.81h0Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.47,615.14c.42.96.44,2.04.06,3.01s-1.12,1.76-2.07,2.19c-.46.23-.96.36-1.48.38-.51.03-1.03-.04-1.51-.22-.48-.17-.93-.44-1.31-.78-.38-.35-.69-.76-.9-1.23l-22.82-50.94c-.42-.96-.44-2.04-.07-3.02.38-.98,1.12-1.76,2.08-2.19.47-.22.97-.34,1.49-.37.51-.02,1.03.06,1.51.23.48.18.93.45,1.31.8s.68.77.9,1.24l22.81,50.88v.02Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.66,613.03c.21.48.22,1.02.03,1.51s-.56.88-1.03,1.1c-.23.11-.48.17-.74.19-.26.01-.51-.03-.75-.11-.24-.09-.46-.22-.65-.39s-.34-.38-.45-.61l-24.42-54.42c-.21-.48-.22-1.02-.03-1.51s.56-.88,1.04-1.09c.23-.11.49-.17.74-.18.26-.01.51.03.76.12.24.09.46.22.65.4.19.17.34.39.45.62l24.39,54.4v-.03Z",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m697.75,402.48c-30.03,14.01-65.73,1.01-79.74-29.02-14-30.03-1.01-65.73,29.02-79.74,30.03-14,65.73-1.01,79.73,29.02,14.01,30.03,1.01,65.73-29.02,79.74Zm-5.07-10.88c11.54-5.38,20.47-15.12,24.82-27.09,4.35-11.96,3.78-25.16-1.6-36.7-5.38-11.54-15.12-20.46-27.09-24.82-11.96-4.35-25.17-3.78-36.7,1.6s-20.46,15.12-24.82,27.09c-4.35,11.96-3.78,25.17,1.6,36.7,5.38,11.54,15.12,20.46,27.09,24.82,11.96,4.35,25.16,3.78,36.7-1.6Zm-23.87-51.19l8.2-22.55,11.28,4.11-8.21,22.55,22.55,8.2-4.11,11.28-22.55-8.21-8.2,22.55-11.28-4.11,8.21-22.55-22.56-8.2,4.11-11.28,22.55,8.21Z",
    fill: "#f1416c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 427.71,
    width: 218,
    height: 41,
    rx: 6,
    ry: 6,
    transform: "translate(-122.06 345.86) rotate(-25)",
    fill: "rgba(217,33,78,.2)"
  })))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(241, 65, 108)",
      fontFamily: "Arial, sans-serif",
      fontSize: "23.7194px",
      fontWeight: 700,
      lineHeight: "36.3697px",
      strokeMiterlimit: 5,
      textTransform: "uppercase",
      whiteSpace: "pre",
      transformBox: "fill-box",
      transformOrigin: "91.3337px 13.6489px"
    },
    transform: "matrix(0.912837, -0.425664, 0.424033, 0.909341, -9.539982, -65.637932)",
    x: 639.421,
    y: 521.737
  }, "NON AUTORIS\xC9"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorizedFr);
export default __webpack_public_path__ + "static/media/unauthorizedFr.8598d575a2d3b00e53fee4b3adb53d05.svg";
export { ForwardRef as ReactComponent };